const Empty = require('constants/empty');

const pageSelector = store => store.page || Empty.Object;

module.exports = { pageSelector };
